import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getJson } from "@/lib/api-client";
import { projectKeys } from "@/lib/query";
import { type PinsResponse, pinsResponseSchema } from "@/schemas/map";
import { photoResponseSchema } from "@/schemas/photos";

export interface MapFilters {
  album?: string;
  from?: string;
  to?: string;
}

export function usePins(projectId: string, filters: MapFilters) {
  return useQuery<PinsResponse>({
    queryKey: projectKeys.pins(projectId, filters),
    queryFn: () => {
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(filters)) {
        if (value) params.set(key, value);
      }
      return getJson(
        `/api/projects/${encodeURIComponent(projectId)}/pins?${params}`,
        pinsResponseSchema,
      );
    },
    placeholderData: keepPreviousData,
  });
}

/** One photo by id, for the viewer opened from a pin. Off until an id is named. */
export function useProjectPhoto(projectId: string, photoId: string | undefined) {
  return useQuery({
    queryKey: projectKeys.photo(projectId, photoId ?? ""),
    enabled: Boolean(photoId),
    queryFn: async () =>
      (
        await getJson(
          `/api/projects/${encodeURIComponent(projectId)}/photos/${encodeURIComponent(photoId ?? "")}`,
          photoResponseSchema,
        )
      ).data,
  });
}
